import { APP_VERSION } from '@/config/constants'
import { tr } from '@/i18n'

/* Port of AppVersionLabelWidget:
 * Padding(24) -> Container(bg secondaryBackground, shadow blur4 0x33000000
 * offset(0,2), radius 12, 1px primary border) -> Padding(8,6) ->
 * Text('v 0.0.21', bodyMedium.override(PoppinsRegular, w500, lineHeight 1)).
 *
 * The w500 override on the single-weight PoppinsRegular family rendered at
 * 400 in Flutter (no synthesis) — so we write 400. Positioning (Align 1,1)
 * belongs to the page, not this component. */

export function AppVersionLabel() {
  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          background: 'var(--secondary-background)',
          boxShadow: '0 2px 4px var(--badge-shadow)',
          borderRadius: 12,
          border: '1px solid var(--primary)',
          padding: '6px 8px',
          display: 'inline-block',
        }}
      >
        <span
          style={{
            fontFamily: 'var(--font-poppins-regular)',
            fontWeight: 400,
            fontSize: 14,
            lineHeight: 1,
            letterSpacing: 0,
            color: 'var(--primary-text)',
          }}
        >
          {tr.version(APP_VERSION)}
        </span>
      </div>
    </div>
  )
}
